// extracted by mini-css-extract-plugin
module.exports = {"dash_item":"styles_dash_item__3gxIT","heading":"styles_heading__ejHWE","quantity":"styles_quantity__2_Ah4","progress":"styles_progress__2xvN6","status":"styles_status__Z0aK6"};